/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	InvitationListResponse,
	InviteMemberRequest,
	InviteMemberResponse,
	MemberListResponse,
	Organization,
	OrganizationListResponse,
	OrganizationRequest,
	OrganizationUpdateResponse,
	PraetoidError,
	SuccessResponse
} from '../models';

/**
 * Deletes an organization. Only organization owners can perform this action
 * @summary Delete an organization
 */
export const deleteOrganization = () => {
	return customInstance<SuccessResponse>({ url: `/organization`, method: 'DELETE' });
};

export const getDeleteOrganizationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteOrganization>>,
		TError,
		void,
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError, void, TContext> => {
	const mutationKey = ['deleteOrganization'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganization>>, void> = () => {
		return deleteOrganization();
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteOrganization>>
>;

export type DeleteOrganizationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete an organization
 */
export const useDeleteOrganization = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteOrganization>>,
			TError,
			void,
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteOrganization>>, TError, void, TContext> => {
	return useMutation(getDeleteOrganizationMutationOptions(options), queryClient);
};
/**
 * Returns the details of a specific organization if the user is a member
 * @summary Get organization details
 */
export const getOrganization = () => {
	return customInstance<Organization>({ url: `/organization`, method: 'GET' });
};

export const getGetOrganizationQueryKey = () => {
	return ['organization'] as const;
};

export const getGetOrganizationQueryOptions = <
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetOrganizationQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = () =>
		getOrganization();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getOrganization>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>;
export type GetOrganizationQueryError = ErrorType<PraetoidError>;

export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getOrganization>>,
					TError,
					Awaited<ReturnType<typeof getOrganization>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getOrganization>>,
					TError,
					Awaited<ReturnType<typeof getOrganization>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization details
 */

export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetOrganizationQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new organization with the authenticated user as the owner
 * @summary Create a new organization
 */
export const createOrganization = (organizationRequest: OrganizationRequest) => {
	return customInstance<Organization>({
		url: `/organization`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: organizationRequest
	});
};

export const getCreateOrganizationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createOrganization>>,
		TError,
		{ data: OrganizationRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createOrganization>>,
	TError,
	{ data: OrganizationRequest },
	TContext
> => {
	const mutationKey = ['createOrganization'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createOrganization>>,
		{ data: OrganizationRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createOrganization(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationBody = OrganizationRequest;
export type CreateOrganizationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create a new organization
 */
export const useCreateOrganization = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createOrganization>>,
			TError,
			{ data: OrganizationRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createOrganization>>,
	TError,
	{ data: OrganizationRequest },
	TContext
> => {
	return useMutation(getCreateOrganizationMutationOptions(options), queryClient);
};
/**
 * Updates an organization's details. Only organization owners can perform this action
 * @summary Update an organization
 */
export const updateOrganization = (organizationRequest: OrganizationRequest) => {
	return customInstance<OrganizationUpdateResponse>({
		url: `/organization`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: organizationRequest
	});
};

export const getUpdateOrganizationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateOrganization>>,
		TError,
		{ data: OrganizationRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateOrganization>>,
	TError,
	{ data: OrganizationRequest },
	TContext
> => {
	const mutationKey = ['updateOrganization'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateOrganization>>,
		{ data: OrganizationRequest }
	> = (props) => {
		const { data } = props ?? {};

		return updateOrganization(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationBody = OrganizationRequest;
export type UpdateOrganizationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update an organization
 */
export const useUpdateOrganization = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateOrganization>>,
			TError,
			{ data: OrganizationRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updateOrganization>>,
	TError,
	{ data: OrganizationRequest },
	TContext
> => {
	return useMutation(getUpdateOrganizationMutationOptions(options), queryClient);
};
/**
 * Lists all pending invitations for the current organization
 * @summary List pending invitations
 */
export const listOrganizationInvitations = () => {
	return customInstance<InvitationListResponse>({
		url: `/organization/invitations`,
		method: 'GET'
	});
};

export const getListOrganizationInvitationsQueryKey = () => {
	return ['organization', 'invitations'] as const;
};

export const getListOrganizationInvitationsQueryOptions = <
	TData = Awaited<ReturnType<typeof listOrganizationInvitations>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listOrganizationInvitations>>, TError, TData>
	>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListOrganizationInvitationsQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationInvitations>>> = () =>
		listOrganizationInvitations();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listOrganizationInvitations>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationInvitationsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listOrganizationInvitations>>
>;
export type ListOrganizationInvitationsQueryError = ErrorType<PraetoidError>;

export function useListOrganizationInvitations<
	TData = Awaited<ReturnType<typeof listOrganizationInvitations>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listOrganizationInvitations>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizationInvitations>>,
					TError,
					Awaited<ReturnType<typeof listOrganizationInvitations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOrganizationInvitations<
	TData = Awaited<ReturnType<typeof listOrganizationInvitations>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listOrganizationInvitations>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizationInvitations>>,
					TError,
					Awaited<ReturnType<typeof listOrganizationInvitations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOrganizationInvitations<
	TData = Awaited<ReturnType<typeof listOrganizationInvitations>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listOrganizationInvitations>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List pending invitations
 */

export function useListOrganizationInvitations<
	TData = Awaited<ReturnType<typeof listOrganizationInvitations>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listOrganizationInvitations>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListOrganizationInvitationsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Revokes a pending invitation
 * @summary Revoke an invitation
 */
export const revokeOrganizationInvitation = (invitationId: string) => {
	return customInstance<SuccessResponse>({
		url: `/organization/invitations/${invitationId}`,
		method: 'DELETE'
	});
};

export const getRevokeOrganizationInvitationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof revokeOrganizationInvitation>>,
		TError,
		{ invitationId: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof revokeOrganizationInvitation>>,
	TError,
	{ invitationId: string },
	TContext
> => {
	const mutationKey = ['revokeOrganizationInvitation'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof revokeOrganizationInvitation>>,
		{ invitationId: string }
	> = (props) => {
		const { invitationId } = props ?? {};

		return revokeOrganizationInvitation(invitationId);
	};

	return { mutationFn, ...mutationOptions };
};

export type RevokeOrganizationInvitationMutationResult = NonNullable<
	Awaited<ReturnType<typeof revokeOrganizationInvitation>>
>;

export type RevokeOrganizationInvitationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Revoke an invitation
 */
export const useRevokeOrganizationInvitation = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof revokeOrganizationInvitation>>,
			TError,
			{ invitationId: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof revokeOrganizationInvitation>>,
	TError,
	{ invitationId: string },
	TContext
> => {
	return useMutation(getRevokeOrganizationInvitationMutationOptions(options), queryClient);
};
/**
 * Regenerates token and resends invitation email
 * @summary Resend an invitation
 */
export const resendOrganizationInvitation = (invitationId: string) => {
	return customInstance<SuccessResponse>({
		url: `/organization/invitations/${invitationId}/resend`,
		method: 'POST'
	});
};

export const getResendOrganizationInvitationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof resendOrganizationInvitation>>,
		TError,
		{ invitationId: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof resendOrganizationInvitation>>,
	TError,
	{ invitationId: string },
	TContext
> => {
	const mutationKey = ['resendOrganizationInvitation'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof resendOrganizationInvitation>>,
		{ invitationId: string }
	> = (props) => {
		const { invitationId } = props ?? {};

		return resendOrganizationInvitation(invitationId);
	};

	return { mutationFn, ...mutationOptions };
};

export type ResendOrganizationInvitationMutationResult = NonNullable<
	Awaited<ReturnType<typeof resendOrganizationInvitation>>
>;

export type ResendOrganizationInvitationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Resend an invitation
 */
export const useResendOrganizationInvitation = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof resendOrganizationInvitation>>,
			TError,
			{ invitationId: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof resendOrganizationInvitation>>,
	TError,
	{ invitationId: string },
	TContext
> => {
	return useMutation(getResendOrganizationInvitationMutationOptions(options), queryClient);
};
/**
 * Accepts an invitation using a token
 * @summary Accept an invitation
 */
export const acceptOrganizationInvitation = (token: string) => {
	return customInstance<SuccessResponse>({
		url: `/organization/invitations/${token}/accept`,
		method: 'POST'
	});
};

export const getAcceptOrganizationInvitationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof acceptOrganizationInvitation>>,
		TError,
		{ token: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof acceptOrganizationInvitation>>,
	TError,
	{ token: string },
	TContext
> => {
	const mutationKey = ['acceptOrganizationInvitation'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof acceptOrganizationInvitation>>,
		{ token: string }
	> = (props) => {
		const { token } = props ?? {};

		return acceptOrganizationInvitation(token);
	};

	return { mutationFn, ...mutationOptions };
};

export type AcceptOrganizationInvitationMutationResult = NonNullable<
	Awaited<ReturnType<typeof acceptOrganizationInvitation>>
>;

export type AcceptOrganizationInvitationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Accept an invitation
 */
export const useAcceptOrganizationInvitation = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof acceptOrganizationInvitation>>,
			TError,
			{ token: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof acceptOrganizationInvitation>>,
	TError,
	{ token: string },
	TContext
> => {
	return useMutation(getAcceptOrganizationInvitationMutationOptions(options), queryClient);
};
/**
 * Lists all members for the current organization
 * @summary List members
 */
export const listOrganizationMembers = () => {
	return customInstance<MemberListResponse>({ url: `/organization/members`, method: 'GET' });
};

export const getListOrganizationMembersQueryKey = () => {
	return ['organization', 'members'] as const;
};

export const getListOrganizationMembersQueryOptions = <
	TData = Awaited<ReturnType<typeof listOrganizationMembers>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>
	>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListOrganizationMembersQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationMembers>>> = () =>
		listOrganizationMembers();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listOrganizationMembers>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationMembersQueryResult = NonNullable<
	Awaited<ReturnType<typeof listOrganizationMembers>>
>;
export type ListOrganizationMembersQueryError = ErrorType<PraetoidError>;

export function useListOrganizationMembers<
	TData = Awaited<ReturnType<typeof listOrganizationMembers>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizationMembers>>,
					TError,
					Awaited<ReturnType<typeof listOrganizationMembers>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOrganizationMembers<
	TData = Awaited<ReturnType<typeof listOrganizationMembers>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizationMembers>>,
					TError,
					Awaited<ReturnType<typeof listOrganizationMembers>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOrganizationMembers<
	TData = Awaited<ReturnType<typeof listOrganizationMembers>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List members
 */

export function useListOrganizationMembers<
	TData = Awaited<ReturnType<typeof listOrganizationMembers>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListOrganizationMembersQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Invites a user by email to the current organization
 * @summary Invite a member
 */
export const inviteOrganizationMember = (inviteMemberRequest: InviteMemberRequest) => {
	return customInstance<InviteMemberResponse>({
		url: `/organization/members/invite`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: inviteMemberRequest
	});
};

export const getInviteOrganizationMemberMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof inviteOrganizationMember>>,
		TError,
		{ data: InviteMemberRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof inviteOrganizationMember>>,
	TError,
	{ data: InviteMemberRequest },
	TContext
> => {
	const mutationKey = ['inviteOrganizationMember'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof inviteOrganizationMember>>,
		{ data: InviteMemberRequest }
	> = (props) => {
		const { data } = props ?? {};

		return inviteOrganizationMember(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type InviteOrganizationMemberMutationResult = NonNullable<
	Awaited<ReturnType<typeof inviteOrganizationMember>>
>;
export type InviteOrganizationMemberMutationBody = InviteMemberRequest;
export type InviteOrganizationMemberMutationError = ErrorType<PraetoidError>;

/**
 * @summary Invite a member
 */
export const useInviteOrganizationMember = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof inviteOrganizationMember>>,
			TError,
			{ data: InviteMemberRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof inviteOrganizationMember>>,
	TError,
	{ data: InviteMemberRequest },
	TContext
> => {
	return useMutation(getInviteOrganizationMemberMutationOptions(options), queryClient);
};
/**
 * Removes a member from the current organization
 * @summary Remove a member
 */
export const removeOrganizationMember = (userId: string) => {
	return customInstance<SuccessResponse>({
		url: `/organization/members/${userId}`,
		method: 'DELETE'
	});
};

export const getRemoveOrganizationMemberMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof removeOrganizationMember>>,
		TError,
		{ userId: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof removeOrganizationMember>>,
	TError,
	{ userId: string },
	TContext
> => {
	const mutationKey = ['removeOrganizationMember'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof removeOrganizationMember>>,
		{ userId: string }
	> = (props) => {
		const { userId } = props ?? {};

		return removeOrganizationMember(userId);
	};

	return { mutationFn, ...mutationOptions };
};

export type RemoveOrganizationMemberMutationResult = NonNullable<
	Awaited<ReturnType<typeof removeOrganizationMember>>
>;

export type RemoveOrganizationMemberMutationError = ErrorType<PraetoidError>;

/**
 * @summary Remove a member
 */
export const useRemoveOrganizationMember = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof removeOrganizationMember>>,
			TError,
			{ userId: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof removeOrganizationMember>>,
	TError,
	{ userId: string },
	TContext
> => {
	return useMutation(getRemoveOrganizationMemberMutationOptions(options), queryClient);
};
/**
 * Returns all organizations that the authenticated user is a member of
 * @summary List user's organizations
 */
export const listOrganizations = () => {
	return customInstance<OrganizationListResponse>({ url: `/organizations`, method: 'GET' });
};

export const getListOrganizationsQueryKey = () => {
	return ['organizations'] as const;
};

export const getListOrganizationsQueryOptions = <
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListOrganizationsQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizations>>> = () =>
		listOrganizations();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listOrganizations>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listOrganizations>>
>;
export type ListOrganizationsQueryError = ErrorType<PraetoidError>;

export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizations>>,
					TError,
					Awaited<ReturnType<typeof listOrganizations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizations>>,
					TError,
					Awaited<ReturnType<typeof listOrganizations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List user's organizations
 */

export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListOrganizationsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
